import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAmazonBrandedDark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAmazonBrandedDark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e46284f015b50c40b550d6988c20f4d460215691', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eaf9d2da9337b1b66b5a6991d93ad12ba9e35bc1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'aea3c015680e52cbc9e1e6218a9dea490d784ac9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.43 14.998a.43.43 0 0 1-.484.05c-.571-.475-.747-.736-1.012-1.127l-.161-.237c-1.122 1.145-1.916 1.487-3.371 1.487-1.72 0-3.06-1.061-3.06-3.187 0-1.66.9-2.79 2.18-3.342.93-.41 2.17-.537 3.246-.647q.311-.031.6-.064v-.416c.003-.45.007-.953-.248-1.33-.25-.376-.728-.532-1.148-.532-.78 0-1.475.4-1.645 1.228-.035.185-.17.366-.354.374l-1.985-.212c-.166-.038-.35-.173-.304-.429.457-2.405 2.628-3.13 4.573-3.13.995 0 2.295.265 3.08 1.019.915.854.909 1.97.902 3.193l-.002.324v3.187c0 .855.317 1.282.65 1.732l.095.127.026.037c.133.184.161.405-.005.543-.418.348-1.16.996-1.568 1.358zm-2.445-2.816c.384-.675.383-1.31.382-2.06v-.551c-1.478 0-3.04.316-3.04 2.06 0 .882.457 1.48 1.242 1.48.576 0 1.09-.353 1.415-.929", fill: "#000" }), h("path", { key: '71b5394bf2bca846d020a46d1fdfaae75caa13c5', d: "M3.92 15.246c2.54 1.549 6.471 3.946 12.737.964.27-.113.459.075.192.416-.27.344-2.42 2.317-6.034 2.317s-6.38-2.468-7.224-3.492c-.232-.266.035-.386.192-.289z", fill: "#FF9A01" }), h("path", { key: '40da3eca711630d271b24ae99c43a6289540ff01', d: "M18.449 15.22c-.171-.223-1.042-.265-1.59-.197-.548.065-1.372.4-1.3.602.027.057.077.051.264.03l.224-.023.088-.009c.433-.045 1.364-.142 1.57.126.221.29-.338 1.674-.44 1.897-.099.223.037.281.223.132.183-.148.514-.533.736-1.077.22-.548.355-1.311.225-1.481", fill: "#FF9A01" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-amazon-branded-dark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-amazon-branded-dark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-amazon-branded-dark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAmazonBrandedDark$1);
            }
            break;
    } });
}

const CosmosIconAmazonBrandedDark = CosmosIconAmazonBrandedDark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAmazonBrandedDark, defineCustomElement };
